import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import pick from 'lodash/pick';
import Slider from 'material-ui/Slider';
import secondsToTime from '../../../utils/secondsToTime';
import css from './preroll-controls.module.scss';

const DEFAULT_TIME = '00:00';

export function PrerollSlider({ timeData, isMinimized }) {
  const time = pick(timeData, ['elapsedSeconds', 'duration', 'elapsedPercent']);
  const seconds = secondsToTime(time.elapsedSeconds) || DEFAULT_TIME;
  const duration = secondsToTime(time.duration) || DEFAULT_TIME;
  const sliderPercentage = time.elapsedPercent || 0;
  return (
    <div>
      <div className={css.prerollSliderTime}>
        <span data-elapsedtime={seconds} id="prerollScrubberElapsed">
          {seconds} / {duration}
        </span>
      </div>
      {!isMinimized && (
        <Slider
          id="prerollScrubber"
          disableFocusRipple
          disabled
          value={sliderPercentage}
          className={css.slider}
          max={100}
        />
      )}
    </div>
  );
}

PrerollSlider.propTypes = {
  isMinimized: PropTypes.bool.isRequired,
  timeData: PropTypes.object,
};

function mapStateToProps(state) {
  const { timeData } = state.preroll;
  return { timeData };
}

export default connect(mapStateToProps)(PrerollSlider);
